export const DEFAULT_ANNOUNCEMENT = Object.freeze({
  enabled: true,
  message:
    "Online and ToGo orders may not be available on Saturdays and Sundays.",
});
export function announcementSettings(content) {
  const value = content?.announcement;
  return value &&
    typeof value.enabled === "boolean" &&
    typeof value.message === "string"
    ? value
    : DEFAULT_ANNOUNCEMENT;
}
